// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "d089ea36",
    "hash": "d089ea36",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "d089ea36",
    "semverString": null,
    "version": "5.0.0"
};
/* tslint:enable */
